/* unplugin-vue-components disabled */import script from "./confirmDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./confirmDialog.vue?vue&type=script&setup=true&lang=js"

import "./confirmDialog.vue?vue&type=style&index=0&id=6c484d9e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c484d9e"]])

export default __exports__